/* entry: index */

import '../../sections/slideshow/slideshow';

import './index.scss';
